import {creates, hoistCmp, HoistProps, uses} from '@xh/hoist/core';
import {DraggableListModel} from './DraggableListModel';
import {div, fragment, span} from '@xh/hoist/cmp/layout';
import classNames from 'classnames';
import {Icon} from '@xh/hoist/icon';
import './DraggableList.scss';

// @ts-ignore
export const draggableList = hoistCmp.factory({
    displayName: 'DraggableList',
    model: creates(DraggableListModel, {publishMode: 'limited'}),
    render({data, model}) {
        return fragment(data.map((data, index) => draggableItem({data, index, key: model.keyGen(data, index)})));
    }
});

export const draggableItem = hoistCmp.factory({
    displayName: 'DraggableItem',
    className: 'draggable-item',
    model: uses(DraggableListModel, {publishMode: 'limited'}),
    render({className, model, data, index}) {
        const {dragging, dragDirection, dropTargetIdx, renderer} = model,
            classes = [className];

        if (dragging) classes.push('draggable-item--dragging');
        if (index === dropTargetIdx) classes.push(`draggable-item--drop-${dragDirection}`);

        return div({
            className: classNames(...classes),
            item: renderer({data, index, model}),
            // @ts-ignore
            onDragEnter: e => model.onDragEnterInternal(e, index),
            // @ts-ignore
            onDragLeave: e => model.onDragLeaveInternal(e, index),
            // @ts-ignore
            onDragOver: e => model.onDragOverInternal(e, index),
            // @ts-ignore
            onDrop: e => model.onDropInternal(e, index)
        });
    }
});

export interface DragHandleProps<T> extends HoistProps<DraggableListModel<T>> {
    index: number;
}

export const dragHandle = hoistCmp.factory({
    displayName: 'DragHandle',
    className: 'drag-handle',
    model: uses(DraggableListModel),
    render({className, model, index, ...rest}) {
        return span({
            className,
            draggable: true,
            item: Icon.grip(),
            // @ts-ignore
            onDragStart: e => model.onDragStartInternal(e, index),
            onDragEnd: () => model.onDragEndInternal(),
            ...rest
        });
    }
});
